import type { TaskStatus } from '@/features/tasks/types';

export function getTaskStatusTone(status: TaskStatus) {
  if (status === 'completed') {
    return 'success' as const;
  }

  if (status === 'inprogress') {
    return 'info' as const;
  }

  if (status === 'archived') {
    return 'warning' as const;
  }

  return 'default' as const;
}

export function getTaskStatusLabel(status: TaskStatus) {
  if (status === 'inprogress') {
    return 'In Progress';
  }

  if (status === 'completed') {
    return 'Completed';
  }

  if (status === 'archived') {
    return 'Archived';
  }

  return 'Backlog';
}
